import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from 'on_web/components/shared/CustomIcons/ExpandMoreIcon';

/**
 * Component displaying one or more paragraphs of text inside collapsible panel (accordion).
 * @param {Component properties} props
 */
export default function ReportsCollapsibleTextSection(props) {
  const [expanded, setExpanded] = useState(
    props.initiallyExpanded ? true : false
  );

  const handleChange = () => (event, newExpanded) => {
    setExpanded(newExpanded ? true : false);
  };

  const sectionTextStyle = {
    fontFamily: 'Museo',
    fontSize: '14px',
    lineHeight: 1.21,
    color: '#222222',
    textAlign: 'left',
  };

  const useStyles = makeStyles(theme => ({
    sectionTitle: {
      fontFamily: 'MuseoSans-500',
      fontSize: 16,
      lineHeight: 1.19,
      color: '#262626',
    },
    sectionText: {
      ...sectionTextStyle,
      margin: '0px 0px 14px',
    },
    sectionTextLast: {
      ...sectionTextStyle,
      margin: '0px 0px 0px',
    },
    sectionTextContainer: {
      padding: '0px 16px 0px',
    },
  }));

  const classes = useStyles();

  return (
    <ExpansionPanel expanded={expanded} onChange={handleChange()}>
      <ExpansionPanelSummary
        expandIcon={<ExpandMoreIcon expanded={expanded} />}
        aria-controls="panel1a-content"
      >
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          style={{ paddingLeft: '50px' }}
        >
          <Grid item>
            <span className={classes.sectionTitle}>{props.title}</span>
          </Grid>
        </Grid>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails className={classes.sectionTextContainer}>
        <Grid
          container
          direction="column"
          justify="flex-start"
          alignItems="stretch"
        >
          {props.paragraphs.map((paragraph, ix) => {
            return (
              <p
                className={
                  ix === props.paragraphs.length - 1
                    ? classes.sectionTextLast
                    : classes.sectionText
                }
                key={ix}
              >
                {paragraph}
              </p>
            );
          })}
        </Grid>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
}

ReportsCollapsibleTextSection.propTypes = {
  /**
   * Section title.
   */
  title: PropTypes.string.isRequired,

  /**
   * Texts to be displayed as paragraphs inside section.
   */
  paragraphs: PropTypes.arrayOf(PropTypes.string).isRequired,
};
